export default "__VITE_ASSET__bOygn4DH__"